import { render, staticRenderFns } from "./BiaodiDetails.vue?vue&type=template&id=7c9a2918&scoped=true&"
import script from "./BiaodiDetails.vue?vue&type=script&lang=js&"
export * from "./BiaodiDetails.vue?vue&type=script&lang=js&"
import style0 from "./BiaodiDetails.vue?vue&type=style&index=0&id=7c9a2918&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c9a2918",
  null
  
)

export default component.exports